import { selectLoggedIn } from 'services/user/selectors'
import { refreshAndReload } from 'services/auth/actions'
import { selectIsPremium, selectUpsellURL } from 'services/premium/selectors'

let _store = null

export function initAuth (store) {
  _store = store
}

function _redirect (nextState) {
  const { location: { search, pathname }} = nextState
  const originalUrl = `${pathname}${search}`
  const next = encodeURIComponent(originalUrl)
  window.location.href = `/auth/login?next=${next}`
}

export function requireAuth (nextState, replace, callback) {
  const state = _store.getState()
  const loggedIn = selectLoggedIn(state)

  if (!loggedIn) {
    _store.dispatch(refreshAndReload({ quiet: true }))
      .then(callback)
      .catch(() => _redirect(nextState))
  } else {
    return callback()
  }

  return loggedIn
}

export function requirePremium (nextState, replace, callback) {
  const state = _store.getState()
  const loggedIn = selectLoggedIn(state)
  const isPremium = selectIsPremium(state)

  if (!loggedIn) {
    _store.dispatch(refreshAndReload({ quiet: true }))
      .then(callback)
      .catch(() => _redirect(nextState))
  } else if (!isPremium) {
    window.location.href = selectUpsellURL(state)
  } else {
    return callback()
  }
}



// WEBPACK FOOTER //
// ./src/shared/auth.js